(function () {
  "use strict";
  var doc = document;
  var STATE = "data-xg-tin-state";
  var LAYERS = 30;
  var SEAM = [14, 15];
  var SPEED = 8;
  var RESUME = 1500;
  var RX0 = -18, RY0 = -32;
  var STEPS = [[6, "4.25rem"], [7, "3.375rem"], [8, "2.875rem"], [9, "2.625rem"], [11, "2.375rem"], [13, "2rem"], [17, "1.625rem"]];
  var FLOOR = "1.375rem";
  var FOOT = "† We print a % Daily Value only where our label data gives one.";
  var LABELS = {
    "energy":          { l: [1, 1],    face: "paper", mark: "top", name: "caps",  fl: "title", art: "dunes",    count: "band",   c: "30 COUNT DIETARY SUPPLEMENTS" },
    "sleep":           { l: [2],       face: "deep",  mark: "br",  name: "serif", fl: "serif", art: "zzz",      count: "center", c: "DIETARY SUPPLEMENT · 30 COUNT" },
    "hangover":        { l: [1, 1],    face: "deep",  mark: "top", name: "caps",  fl: "bold",  art: "aurora",   count: "center", c: "DIETARY SUPPLEMENT|30 oral strips" },
    "cognitive-relax": { l: [1, 2],    face: "wash",  mark: "br",  name: "caps",  fl: "caps",  art: "brain",    count: "center", c: "DIETARY SUPPLEMENTS|30 ORAL STRIPS" },
    "mushroom-focus":  { l: [1, 2],    face: "deep",  mark: "bl",  name: "caps",  fl: "caps",  art: "mushroom", count: "center", c: "30ct DIETARY SUPPLEMENTS" },
    "probiotic":       { l: [2, 1, 1], face: "arch",  mark: "br",  name: "title", fl: "title", art: "arch",     count: "left",   c: "30ct DIETARY SUPPLEMENTS" },
    "appetite":        { l: [1, 1, 1], face: "deep",  mark: "br",  name: "caps",  fl: "caps",  art: "",         count: "left",   c: "30ct Dietary Supplements" },
    "bone-support":    { l: [1, 1, 1], face: "deep",  mark: "top", name: "caps",  fl: "caps",  art: "shield",   count: "center", c: "30ct Dietary Supplement" },
    "iron":            { l: [1, 1],    face: "paper", mark: "tl",  name: "caps",  fl: "caps",  art: "brush",    count: "center", c: "DIETARY SUPPLEMENT|30 ORAL STRIPS" },
    "beauty":          { l: [2, 1, 1], face: "wash",  mark: "top", name: "serif", fl: "title", art: "bokeh",    count: "center", c: "DIETARY SUPPLEMENTS · 30 COUNT" },
    "intimate":        { l: [2, 1],    face: "deep",  mark: "tr",  name: "serif", fl: "serif", art: "symbols",  count: "center", c: "DIETARY SUPPLEMENT 30 COUNT" }
  };
  var DEFAULT = { l: null, face: "paper", mark: "top", name: "caps", fl: "title", art: "dunes", count: "band", c: "30 COUNT DIETARY SUPPLEMENTS" };
  function reduced() {
    var m = typeof window.matchMedia === "function"
      ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    return !!(m && m.matches);
  }
  function supports3d() {
    return !!(window.CSS && CSS.supports && CSS.supports("transform-style", "preserve-3d"));
  }
  function el(tag, cls, text, parent) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    if (parent) parent.appendChild(n);
    return n;
  }
  var NS = "http://www.w3.org/2000/svg";
  function svg(tag, attrs, parent) {
    var n = doc.createElementNS(NS, tag);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function gradient(defs, id, x2, y2, stops) {
    var g = svg("linearGradient", { id: id, x1: "0", y1: "0", x2: x2, y2: y2 }, defs);
    for (var i = 0; i < stops.length; i += 1) svg("stop", { offset: stops[i][0], style: stops[i][1] }, g);
  }
  function c(n) { return "fill: var(--xg-tin-c" + n + ")"; }
  function line(n, w) { return "fill: none; stroke: var(--xg-tin-c" + n + "); stroke-width: " + w + "; stroke-linecap: round; stroke-linejoin: round"; }
  function circles(g, pts, r, style) {
    for (var i = 0; i < pts.length; i += 1) svg("circle", { cx: String(pts[i][0]), cy: String(pts[i][1]), r: String(r), style: style }, g);
  }
  function mark(parent) {
    var s = svg("svg", { "class": "xg-tin__mark", viewBox: "0 0 32 32", "aria-hidden": "true", focusable: "false" }, parent);
    gradient(svg("defs", {}, s), "xg-tin-mark-grad", "1", "1",
      [["0", "stop-color: var(--xg-brand-violet)"], ["1", "stop-color: var(--xg-brand-blue)"]]);
    var g = svg("g", {}, s);
    svg("path", { d: "M7 7 L25 25 M25 7 L7 25", style: "fill: none; stroke: url(#xg-tin-mark-grad); stroke-width: 3; stroke-linecap: round" }, g);
    circles(g, [[7, 7], [25, 7], [7, 25], [25, 25]], 4.2, "fill: url(#xg-tin-mark-grad)");
    svg("circle", { cx: "16", cy: "16", r: "3.4", style: "fill: url(#xg-tin-mark-grad)" }, g);
  }
  function art(key, parent) {
    if (!key) return;
    var s = svg("svg", { "class": "xg-tin__art", viewBox: "0 0 360 360", preserveAspectRatio: "none", "aria-hidden": "true", focusable: "false" }, parent);
    var i;
    if (key === "dunes") {
      svg("path", { d: "M0 250 C60 225 110 225 170 245 S300 270 360 240 L360 360 L0 360 Z", style: c(4) }, s);
      svg("path", { d: "M0 285 C70 260 130 262 190 282 S310 300 360 275 L360 360 L0 360 Z", style: c(2) }, s);
      svg("path", { d: "M0 318 C80 298 150 300 215 316 S320 330 360 312 L360 360 L0 360 Z", style: c(1) }, s);
    } else if (key === "zzz") {
      var zs = [[214, 118, 30, -14], [246, 92, 38, -14], [284, 62, 48, -12], [326, 30, 60, -10]];
      for (i = 0; i < zs.length; i += 1) {
        svg("text", { x: String(zs[i][0]), y: String(zs[i][1]), "font-size": String(zs[i][2]), "font-weight": "600",
          transform: "rotate(" + zs[i][3] + " " + zs[i][0] + " " + zs[i][1] + ")", style: c(3) }, s).textContent = "Z";
      }
      var berry = [[50, 254], [84, 274]];
      for (i = 0; i < berry.length; i += 1) {
        var bx = berry[i][0], by = berry[i][1];
        circles(s, [[bx - 9, by - 8], [bx, by - 11], [bx + 9, by - 8], [bx - 11, by + 2], [bx, by], [bx + 11, by + 2], [bx - 7, by + 11], [bx + 7, by + 11], [bx, by + 16]], 5.5, c(1));
        svg("path", { d: "M" + (bx - 4) + " " + (by - 16) + " q4 -14 16 -12 q-4 12 -16 12 Z", style: c(3) + "; opacity: 0.8" }, s);
      }
    } else if (key === "aurora") {
      svg("ellipse", { "class": "xg-tin__glow", cx: "180", cy: "200", rx: "250", ry: "142", transform: "rotate(-22 180 200)", style: line(1, 24) + "; opacity: 0.85" }, s);
      svg("ellipse", { "class": "xg-tin__glow", cx: "186", cy: "206", rx: "274", ry: "166", transform: "rotate(-22 186 206)", style: line(2, 12) + "; opacity: 0.6" }, s);
      svg("ellipse", { "class": "xg-tin__glow", cx: "176", cy: "196", rx: "226", ry: "124", transform: "rotate(-22 176 196)", style: line(3, 5) + "; opacity: 0.4" }, s);
    } else if (key === "brain") {
      var g = svg("g", { transform: "translate(180 88)", style: line(5, 5) }, s);
      svg("path", { d: "M0 -46 C-14 -60 -46 -56 -52 -34 C-72 -30 -74 6 -56 18 C-58 40 -30 52 -8 40 L0 44 L8 40 C30 52 58 40 56 18 C74 6 72 -30 52 -34 C46 -56 14 -60 0 -46 Z" }, g);
      svg("path", { d: "M0 -46 L0 44 M-52 -34 C-36 -30 -30 -12 -40 0 M-56 18 C-40 10 -22 16 -18 30 M52 -34 C36 -30 30 -12 40 0 M56 18 C40 10 22 16 18 30 M-26 -40 C-16 -28 -2 -30 -6 -10 M26 -40 C16 -28 2 -30 6 -10" }, g);
    } else if (key === "mushroom") {
      svg("path", { d: "M104 120 C104 60 256 60 256 120 C256 134 236 138 180 138 C124 138 104 134 104 120 Z", style: c(1) }, s);
      circles(s, [[142, 96], [188, 82], [222, 104]], 10, c(3) + "; opacity: 0.55");
      svg("path", { d: "M160 136 L154 186 Q180 196 206 186 L200 136 Z", style: c(4) }, s);
      svg("rect", { x: "206", y: "160", width: "34", height: "34", rx: "5", transform: "rotate(-14 223 177)", style: c(5) }, s);
      svg("path", { d: "M150 190 C170 202 200 204 216 194 C214 206 190 212 172 206 Z", style: c(5) + "; opacity: 0.8" }, s);
    } else if (key === "arch") {
      svg("path", { d: "M34 360 L34 190 C34 128 100 110 150 78 C166 68 174 50 180 26 C186 50 194 68 210 78 C260 110 326 128 326 190 L326 360 Z", style: c(3) }, s);
      circles(s, [[171, 286], [180, 281], [189, 286], [168, 295], [180, 292], [192, 295], [174, 304], [186, 304]], 5, c(5));
      svg("path", { d: "M176 276 q4 -12 14 -10 q-4 10 -14 10 Z", style: c(2) }, s);
    } else if (key === "shield") {
      svg("path", { d: "M180 40 L282 78 L282 172 C282 236 234 288 180 314 C126 288 78 236 78 172 L78 78 Z", style: c(3) + "; opacity: 0.14" }, s);
      svg("path", { d: "M180 70 L256 98 L256 170 C256 220 220 260 180 282 C140 260 104 220 104 170 L104 98 Z", style: line(3, 3) + "; opacity: 0.18" }, s);
    } else if (key === "brush") {
      svg("path", { d: "M-20 40 C60 10 140 30 220 0 S330 -30 380 -20 L380 20 C300 40 220 60 140 70 S30 90 -20 100 Z", style: c(1) }, s);
      svg("path", { d: "M-20 60 C80 40 170 54 250 30 S340 -6 380 6 L380 16 C300 40 210 66 130 78 S30 100 -20 110 Z", style: c(3) + "; opacity: 0.35" }, s);
      svg("path", { d: "M-20 300 C60 280 140 296 220 276 S330 246 380 262 L380 380 L-20 380 Z", style: c(1) }, s);
      svg("path", { d: "M-20 330 C80 306 170 318 250 298 S340 280 380 300 L380 316 C300 330 210 340 130 350 S30 352 -20 352 Z", style: c(3) + "; opacity: 0.35" }, s);
      var m = svg("g", { transform: "translate(180 112)" }, s);
      svg("path", { d: "M0 0 L-30 -22 M0 0 L30 -22 M0 0 L0 36 M-46 -2 L-72 6 M-40 12 L-66 22 M-48 -18 L-70 -16", style: line(1, 5) }, m);
      circles(m, [[0, 0], [-30, -22], [30, -22], [0, 36]], 11, c(1));
      circles(m, [[-4, -4], [-34, -26], [26, -26], [-4, 32]], 3.5, c(3) + "; opacity: 0.6");
    } else if (key === "bokeh") {
      var dots = [[40, 60, 14], [96, 30, 8], [300, 44, 18], [330, 120, 9], [26, 170, 10], [320, 250, 12], [60, 300, 16], [270, 320, 7], [150, 330, 6], [230, 22, 5]];
      for (i = 0; i < dots.length; i += 1) svg("circle", { cx: String(dots[i][0]), cy: String(dots[i][1]), r: String(dots[i][2]), style: c(1) + "; opacity: 0.28" }, s);
      svg("path", { d: "M60 104 L64 90 L68 104 L82 108 L68 112 L64 126 L60 112 L46 108 Z", style: c(3) }, s);
      svg("path", { d: "M-10 262 C50 232 90 292 150 262 S250 232 310 262 S370 292 400 262", style: line(3, 9) + "; opacity: 0.7" }, s);
      svg("path", { d: "M-10 274 C50 244 90 304 150 274 S250 244 310 274 S370 304 400 274", style: line(2, 4) + "; opacity: 0.5" }, s);
    } else if (key === "symbols") {
      var sy = svg("g", { style: line(4, 6) }, s);
      svg("circle", { cx: "134", cy: "116", r: "28" }, sy);
      svg("path", { d: "M154 96 L184 66 M184 66 L162 66 M184 66 L184 88" }, sy);
      svg("circle", { cx: "226", cy: "100", r: "28" }, sy);
      svg("path", { d: "M226 128 L226 172 M208 152 L244 152" }, sy);
    }
    return s;
  }
  function layers(body) {
    for (var i = 0; i < LAYERS; i += 1) {
      var d = el("div", "xg-tin__layer" + (SEAM.indexOf(i) >= 0 ? " xg-tin__layer--seam" : ""), null, body);
      d.style.setProperty("--xg-tin-z", String(i));
    }
  }
  function build(zone) {
    if (zone.querySelector("[data-xg-tin-body]")) return;
    var stage = el("div", "xg-tin__stage", null, zone);
    stage.setAttribute("data-xg-tin-stage", "");
    stage.setAttribute("aria-hidden", "true");
    var body = el("div", "xg-tin__body", null, stage);
    body.setAttribute("data-xg-tin-body", "");
    if (supports3d()) layers(body);
    var back = el("div", "xg-tin__face xg-tin__face--back", null, body);
    var facts = el("div", "xg-tin__facts", null, back);
    el("p", "xg-tin__facts-title", "Supplement Facts", facts);
    el("p", "xg-tin__facts-meta", "", facts).setAttribute("data-xg-tin-serving", "");
    el("p", "xg-tin__facts-meta", "", facts).setAttribute("data-xg-tin-per", "");
    var table = el("table", "xg-tin__facts-table", null, facts);
    var hr = el("tr", null, null, el("thead", null, null, table));
    el("th", "xg-tin__hd xg-tin__hd--name", "", hr);
    el("th", "xg-tin__hd", "Amount per serving", hr);
    el("th", "xg-tin__hd", "% DV", hr);
    el("tbody", null, null, table).setAttribute("data-xg-tin-rows", "");
    el("p", "xg-tin__facts-foot", FOOT, facts);
    el("div", "xg-tin__face xg-tin__face--front", null, body).setAttribute("data-xg-tin-front", "");
    el("div", "xg-tin__shadow", null, stage);
  }
  function size(n) {
    for (var i = 0; i < STEPS.length; i += 1) if (n <= STEPS[i][0]) return STEPS[i][1];
    return FLOOR;
  }
  function split(name, pat) {
    var words = String(name || "").trim().split(/\s+/), lines = [], i = 0, k;
    if (!pat) return words.length > 1 ? [words.slice(0, -1).join(" "), words[words.length - 1]] : [words[0]];
    for (k = 0; k < pat.length && i < words.length; k += 1) { lines.push(words.slice(i, i + pat[k]).join(" ")); i += pat[k]; }
    if (i < words.length) lines[lines.length - 1] = (lines[lines.length - 1] + " " + words.slice(i).join(" ")).trim();
    return lines;
  }
  function lid(front, s, spec) {
    front.replaceChildren();
    front.setAttribute("data-xg-tin-face", spec.face);
    front.setAttribute("data-xg-tin-mark", spec.mark);
    front.setAttribute("data-xg-tin-art", spec.art || "none");
    front.setAttribute("data-xg-tin-count", spec.count);
    art(spec.art, front);
    var brand = el("div", "xg-tin__brand", null, front);
    mark(brand);
    el("span", "xg-tin__wordmark", "XYNE", brand);
    var copy = el("div", "xg-tin__copy", null, front);
    var name = el("div", "xg-tin__name", null, copy);
    name.setAttribute("data-xg-tin-name", "");
    name.setAttribute("data-xg-tin-style", spec.name);
    var lines = split(s.name, spec.l), longest = 0, i;
    for (i = 0; i < lines.length; i += 1) { el("span", null, lines[i], name); longest = Math.max(longest, lines[i].length); }
    var flavor = el("div", "xg-tin__flavor", null, copy);
    flavor.setAttribute("data-xg-tin-style", spec.fl);
    el("span", "xg-tin__flavor-text", s.flavor ? s.flavor + " flavor" : "", flavor).setAttribute("data-xg-tin-flavor", "");
    var count = el("div", "xg-tin__count", null, front);
    var parts = spec.c.split("|");
    for (i = 0; i < parts.length; i += 1) el("span", null, parts[i], count);
    return longest;
  }
  function draw(zone, s) {
    if (!zone || !s) return;
    var front = zone.querySelector("[data-xg-tin-front]");
    var spec = Object.prototype.hasOwnProperty.call(LABELS, s.id) ? LABELS[s.id] : DEFAULT;
    if (front) zone.style.setProperty("--xg-tin-name", size(lid(front, s, spec)));
    var sv = zone.querySelector("[data-xg-tin-serving]");
    if (sv) sv.textContent = s.sf.serving;
    var pr = zone.querySelector("[data-xg-tin-per]");
    if (pr) pr.textContent = s.sf.per;
    var rows = zone.querySelector("[data-xg-tin-rows]");
    if (rows) {
      rows.replaceChildren();
      for (var r = 0; r < s.sf.rows.length; r += 1) {
        var tr = el("tr", null, null, rows);
        el("th", null, s.sf.rows[r].n, tr);
        el("td", null, s.sf.rows[r].v, tr);
        el("td", null, s.sf.rows[r].d || "†", tr);
      }
    }
    var label = zone.getAttribute("aria-label") || "";
    zone.setAttribute("aria-label", s.name + ": " + label.slice(label.indexOf(": ") + 2));
  }
  function active(zone) {
    var root = zone.closest("[data-xg-pdp]") || doc.querySelector("[data-xg-pdp]");
    var island = doc.querySelector("[data-xg-pdp-data]");
    if (!root || !island) return null;
    var id = root.getAttribute("data-xg-active");
    try {
      var data = JSON.parse(island.textContent);
      for (var i = 0; i < data.length; i += 1) if (data[i].id === id) return data[i];
    } catch (e) { return null; }
    return null;
  }
  function arm(zone) {
    build(zone);
    draw(zone, active(zone));
    var body = zone.querySelector("[data-xg-tin-body]");
    zone.removeAttribute("hidden");
    var rx = RX0, ry = RY0;
    var dragging = false, pointerId = null;
    var sx = 0, sy = 0, srx = 0, sry = 0;
    var raf = null, last = 0, inView = true, resume = null;
    function set() {
      body.style.setProperty("--xg-tin-rx", rx + "deg");
      body.style.setProperty("--xg-tin-ry", ry + "deg");
    }
    function tick(now) {
      if (dragging || !inView) { raf = null; return; }
      var dt = last ? (now - last) / 1000 : 0;
      last = now;
      if (dt > 0 && dt < 0.1) { ry += SPEED * dt; set(); }
      raf = window.requestAnimationFrame(tick);
    }
    function start() {
      if (raf || reduced() || !supports3d()) { zone.setAttribute(STATE, supports3d() ? "still" : "flat"); return; }
      zone.setAttribute(STATE, "turning");
      last = 0;
      raf = window.requestAnimationFrame(tick);
    }
    function stop() {
      if (raf) { window.cancelAnimationFrame(raf); raf = null; }
      if (resume) { window.clearTimeout(resume); resume = null; }
      if (zone.getAttribute(STATE) === "turning") zone.setAttribute(STATE, "still");
    }
    set();
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          inView = entries[i].isIntersecting;
          if (inView && !dragging) start(); else stop();
        }
      }, { threshold: 0.15 }).observe(zone);
    }
    function move(e) {
      if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
      ry = sry + (e.clientX - sx) * 0.5;
      rx = Math.max(-80, Math.min(80, srx - (e.clientY - sy) * 0.5));
      set();
    }
    function end(e) {
      if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      zone.removeAttribute("data-xg-tin-drag");
      zone.setAttribute(STATE, "still");
      doc.removeEventListener("pointermove", move);
      doc.removeEventListener("pointerup", end);
      doc.removeEventListener("pointercancel", end);
      if (resume) window.clearTimeout(resume);
      resume = window.setTimeout(function () { if (!dragging && inView) start(); }, RESUME);
    }
    zone.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      zone.setAttribute("data-xg-tin-drag", "");
      zone.setAttribute(STATE, "dragging");
      sx = e.clientX; sy = e.clientY; srx = rx; sry = ry;
      stop();
      body.removeAttribute("data-xg-tin-snap");
      doc.addEventListener("pointermove", move);
      doc.addEventListener("pointerup", end);
      doc.addEventListener("pointercancel", end);
    });
    zone.addEventListener("dblclick", function () {
      rx = RX0; ry = RY0;
      body.setAttribute("data-xg-tin-snap", "");
      set();
      window.setTimeout(function () { body.removeAttribute("data-xg-tin-snap"); }, 700);
    });
    var m = typeof window.matchMedia === "function"
      ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    if (m) {
      var onChange = function () { if (m.matches) stop(); else if (inView && !dragging) start(); };
      if (m.addEventListener) m.addEventListener("change", onChange);
      else if (m.addListener) m.addListener(onChange);
    }
    start();
  }
  function styled(zone) {
    return getComputedStyle(zone).perspective !== "none";
  }
  function whenStyled(zone, fn) {
    if (styled(zone)) { fn(); return; }
    var link = doc.querySelector("link[data-xg-tin-css]");
    if (!link) return;
    link.addEventListener("load", function () { if (styled(zone)) fn(); }, { once: true });
  }
  function init(root) {
    var scope = root && root.querySelectorAll ? root : doc;
    var zones = scope.querySelectorAll("[data-xg-tin]");
    for (var i = 0; i < zones.length; i += 1) {
      (function (zone) {
        if (zone.hasAttribute(STATE)) return;
        zone.setAttribute(STATE, "loading");
        whenStyled(zone, function () { arm(zone); });
      })(zones[i]);
    }
  }
  function redraw(root, record) {
    var scope = root && root.querySelectorAll ? root : doc;
    var zones = scope.querySelectorAll("[data-xg-tin]");
    for (var i = 0; i < zones.length; i += 1) draw(zones[i], record);
  }
  if (doc.readyState === "complete") init(doc);
  else window.addEventListener("load", function () { init(doc); }, { once: true });
  doc.addEventListener("shopify:section:load", function (event) { init(event.target); });
  window.XG = window.XG || {};
  window.XG.tin = { init: init, draw: redraw };
})();
